import React, { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Trans } from 'react-i18next';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { FacebookTokenControlProps } from 'src/components/FacebookToken/FacebookTokenControl.types';

export const FacebookTokenControl: React.FC<FacebookTokenControlProps> = ({
  expiresAt,
  shouldRenew,
  onToggle,
  onFbSuccess,
  fbLoginRef,
  renewAccessTokenLoading,
}) => {
  const [fbPopupOpen, setFbPopupOpen] = useState<boolean>(false);

  if (!expiresAt || renewAccessTokenLoading) {
    return <CircularProgress size={24} />;
  }

  return (
    <Box>
      <FacebookLogin
        appId="1219762215938055"
        scope="pages_manage_posts,pages_show_list"
        onSuccess={response => {
          onFbSuccess(response);
          setFbPopupOpen(false);
        }}
        onFail={() => setFbPopupOpen(false)}
        render={renderProps => (
          <Button
            style={{ display: 'none' }}
            onClick={() => {
              setFbPopupOpen(true);
              renderProps.onClick?.();
            }}
            ref={fbLoginRef}
          />
        )}
      />
      <Button
        onClick={onToggle}
        variant="contained"
        color="primary"
        disabled={!shouldRenew || renewAccessTokenLoading || fbPopupOpen}>
        <Trans>configScreen.facebookToken.renewButton</Trans>
      </Button>
    </Box>
  );
};
